var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", [
        _vm.requestCallbackSent
          ? _c("div", [
              _c("label", { staticClass: "label-large" }, [
                _vm._v("Our Vet Nurse will call you shortly"),
              ]),
            ])
          : _c("div", [
              _c("div", { staticClass: "row align-items-center mb-4" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "TitleInput" } }, [
                      _vm._v("Title"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalDetails.title,
                            expression: "personalDetails.title",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "is-invalid": _vm.errors.has("TitleInput"),
                        },
                        attrs: {
                          type: "text",
                          id: "TitleInput",
                          name: "TitleInput",
                          "data-vv-as": '"Title"',
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.personalDetails,
                              "title",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("- Select -"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.titleList, function (option) {
                          return _c(
                            "option",
                            { key: option, domProps: { value: option } },
                            [_vm._v(" " + _vm._s(option) + " ")]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("TitleInput"),
                            expression: "errors.has('TitleInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("TitleInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "FirstNameInput" } }, [
                      _vm._v("First name"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.personalDetails.firstName,
                          expression: "personalDetails.firstName",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      class: {
                        "form-control": true,
                        "is-invalid": _vm.errors.has("FirstNameInput"),
                      },
                      attrs: {
                        type: "text",
                        id: "FirstNameInput",
                        autocomplete: "new-password",
                        name: "FirstNameInput",
                        "data-vv-as": '"First name"',
                      },
                      domProps: { value: _vm.personalDetails.firstName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.personalDetails,
                            "firstName",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("FirstNameInput"),
                            expression: "errors.has('FirstNameInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("FirstNameInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "LastNameInput" } }, [
                      _vm._v("Last name"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.personalDetails.lastName,
                          expression: "personalDetails.lastName",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      class: {
                        "form-control": true,
                        "is-invalid": _vm.errors.has("LastNameInput"),
                      },
                      attrs: {
                        type: "text",
                        id: "LastNameInput",
                        name: "LastNameInput",
                        autocomplete: "new-password",
                        "data-vv-as": '"Last name"',
                      },
                      domProps: { value: _vm.personalDetails.lastName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.personalDetails,
                            "lastName",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("LastNameInput"),
                            expression: "errors.has('LastNameInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("LastNameInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "TelephoneInput" } }, [
                      _vm._v("Telephone"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.personalDetails.telephone,
                          expression: "personalDetails.telephone",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|phone",
                          expression: "'required|phone'",
                        },
                      ],
                      class: {
                        "form-control": true,
                        "is-invalid": _vm.errors.has("TelephoneInput"),
                      },
                      attrs: {
                        type: "text",
                        id: "TelephoneInput",
                        autocomplete: "new-password",
                        name: "TelephoneInput",
                        "data-vv-as": '"Telephone"',
                      },
                      domProps: { value: _vm.personalDetails.telephone },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.personalDetails,
                            "telephone",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("TelephoneInput"),
                            expression: "errors.has('TelephoneInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("TelephoneInput")))]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row align-items-center mb-4" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        attrs: {
                          "data-toggle": "tooltip",
                          for: "PetNameInput",
                        },
                      },
                      [_vm._v("Pet name")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.petDetails.name,
                          expression: "petDetails.name",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      class: {
                        "form-control": true,
                        "is-invalid": _vm.errors.has("PetNameInput"),
                      },
                      attrs: {
                        type: "text",
                        id: "PetNameInput",
                        autocomplete: "new-password",
                        name: "PetNameInput",
                        "data-vv-as": '"Pet name"',
                      },
                      domProps: { value: _vm.petDetails.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.petDetails, "name", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("PetNameInput"),
                            expression: "errors.has('PetNameInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("PetNameInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        attrs: { "data-toggle": "tooltip", for: "petAgeInput" },
                      },
                      [_vm._v("Pet age")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.petDetails.petAge,
                            expression: "petDetails.petAge",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "is-invalid": _vm.errors.has("petAgeInput"),
                        },
                        attrs: {
                          id: "petAgeInput",
                          name: "petAgeInput",
                          "data-vv-as": '"Pet age"',
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.petDetails,
                              "petAge",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: { selected: "" },
                            domProps: { value: null },
                          },
                          [_vm._v(" - Select - ")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.petAgeList, function (option) {
                          return _c(
                            "option",
                            { key: option.id, domProps: { value: option.id } },
                            [_vm._v(_vm._s(option.name))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("petAgeInput"),
                            expression: "errors.has('petAgeInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("petAgeInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        attrs: {
                          "data-toggle": "tooltip",
                          for: "SpeciesInput",
                        },
                      },
                      [_vm._v("Pet Type")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.petDetails.speciesId,
                            expression: "petDetails.speciesId",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "is-invalid": _vm.errors.has("SpeciesInput"),
                        },
                        attrs: {
                          id: "SpeciesInput",
                          name: "SpeciesInput",
                          "data-vv-as": '"Pet Type"',
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.petDetails,
                                "speciesId",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            _vm.onSelectedSpeciesChange,
                          ],
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: { selected: "" },
                            domProps: { value: null },
                          },
                          [_vm._v(" - Select - ")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.species, function (option) {
                          return _c(
                            "option",
                            { key: option.id, domProps: { value: option.id } },
                            [_vm._v(_vm._s(option.name))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("SpeciesInput"),
                            expression: "errors.has('SpeciesInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("SpeciesInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        attrs: { "data-toggle": "tooltip", for: "BreedInput" },
                      },
                      [_vm._v("Breed")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.petDetails.breedId,
                            expression: "petDetails.breedId",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "is-invalid": _vm.errors.has("BreedInput"),
                        },
                        attrs: {
                          id: "BreedInput",
                          name: "BreedInput",
                          "data-vv-as": '"Breed"',
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.petDetails,
                              "breedId",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: { selected: "" },
                            domProps: { value: null },
                          },
                          [_vm._v(" - Select - ")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.availableBreeds, function (option) {
                          return _c(
                            "option",
                            { key: option.id, domProps: { value: option.id } },
                            [_vm._v(_vm._s(option.name))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("BreedInput"),
                            expression: "errors.has('BreedInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("BreedInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        attrs: { "data-toggle": "tooltip", for: "petSexInput" },
                      },
                      [_vm._v("Pet sex")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "multiselect-control row align-items-center": true,
                          "is-invalid": _vm.errors.has("petSexInput"),
                        },
                      },
                      [
                        _c("div", { staticClass: "col-auto" }, [
                          _c("label", { attrs: { for: "female" } }, [
                            _vm._v(
                              "\n                                Female\n                                "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.petDetails.sex,
                                  expression: "petDetails.sex",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                id: "female",
                                name: "petSexInput",
                                type: "radio",
                                "data-vv-as": '"Pet sex"',
                              },
                              domProps: {
                                value: "" + _vm.genderFemale,
                                checked: _vm._q(
                                  _vm.petDetails.sex,
                                  "" + _vm.genderFemale
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    _vm.petDetails,
                                    "sex",
                                    "" + _vm.genderFemale
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-auto" }, [
                          _c("label", { attrs: { for: "male" } }, [
                            _vm._v(
                              "\n                                Male\n                                "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.petDetails.sex,
                                  expression: "petDetails.sex",
                                },
                              ],
                              attrs: {
                                id: "male",
                                name: "petSexInput",
                                type: "radio",
                              },
                              domProps: {
                                value: "" + _vm.genderMale,
                                checked: _vm._q(
                                  _vm.petDetails.sex,
                                  "" + _vm.genderMale
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    _vm.petDetails,
                                    "sex",
                                    "" + _vm.genderMale
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("petSexInput"),
                            expression: "errors.has('petSexInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("petSexInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        attrs: {
                          "data-toggle": "tooltip",
                          for: "isSeeingAVetInput",
                        },
                      },
                      [
                        _vm._v(
                          "Is your pet currently seeing a vet about the problem you're calling about? "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.petDetails.isSeeingAVet,
                            expression: "petDetails.isSeeingAVet",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "is-invalid": _vm.errors.has("isSeeingAVetInput"),
                        },
                        attrs: {
                          id: "isSeeingAVetInput",
                          name: "isSeeingAVetInput",
                          "data-vv-as": '"Is seeing a Vet?"',
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.petDetails,
                                "isSeeingAVet",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            _vm.onSeeingVetChange,
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v(" - Select - "),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.seeingVetAnswers, function (option) {
                          return _c(
                            "option",
                            { key: option.id, domProps: { value: option.id } },
                            [_vm._v(_vm._s(option.name))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("isSeeingAVetInput"),
                            expression: "errors.has('isSeeingAVetInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("isSeeingAVetInput")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !this.errors.has("isSeeingAVetInput") &&
                              _vm.seeingAVetWarning,
                            expression:
                              "!this.errors.has('isSeeingAVetInput') && seeingAVetWarning",
                          },
                        ],
                        staticStyle: { margin: "0 0 1em" },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "text-danger",
                            staticStyle: { "white-space": "pre-line" },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.secondOpinionQuestion) + " "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: {
                              "multiselect-control row align-items-center": true,
                              "is-invalid":
                                _vm.errors.has("secondOpinionInput"),
                            },
                          },
                          [
                            _c("div", { staticClass: "col-auto" }, [
                              _c(
                                "label",
                                { attrs: { for: "secondOpinionYesInput" } },
                                [
                                  _vm._v(
                                    "\n                                    Yes\n                                    "
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.petDetails.secondOpinion,
                                        expression: "petDetails.secondOpinion",
                                      },
                                    ],
                                    attrs: {
                                      id: "secondOpinionYesInput",
                                      name: "secondOpinionInput",
                                      type: "radio",
                                    },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(
                                        _vm.petDetails.secondOpinion,
                                        true
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.petDetails,
                                          "secondOpinion",
                                          true
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-auto" }, [
                              _c(
                                "label",
                                { attrs: { for: "secondOpinionNoInput" } },
                                [
                                  _vm._v(
                                    "\n                                    No\n                                    "
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.petDetails.secondOpinion,
                                        expression: "petDetails.secondOpinion",
                                      },
                                    ],
                                    attrs: {
                                      id: "secondOpinionNoInput",
                                      name: "secondOpinionInput",
                                      type: "radio",
                                    },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(
                                        _vm.petDetails.secondOpinion,
                                        false
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.petDetails,
                                          "secondOpinion",
                                          false
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isSecondOpinionOk,
                                expression: "!isSecondOpinionOk",
                              },
                            ],
                            staticClass: "text-danger",
                          },
                          [
                            _vm._v(
                              "Unfortunately, we are unable to proceed unless you are willing to accept our advice as a second opinion."
                            ),
                            _c("br"),
                            _c("strong", [_vm._v("Please contact your vet")]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        attrs: {
                          "data-toggle": "tooltip",
                          for: "isOnMedicationInput",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.petDetails.isOnMedication,
                              expression: "petDetails.isOnMedication",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            id: "isOnMedicationInput",
                            autocomplete: "new-password",
                            name: "isOnMedicationInput",
                          },
                          domProps: {
                            checked: Array.isArray(
                              _vm.petDetails.isOnMedication
                            )
                              ? _vm._i(_vm.petDetails.isOnMedication, null) > -1
                              : _vm.petDetails.isOnMedication,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.petDetails.isOnMedication,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.petDetails,
                                        "isOnMedication",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.petDetails,
                                        "isOnMedication",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.petDetails,
                                    "isOnMedication",
                                    $$c
                                  )
                                }
                              },
                              _vm.resetMedicationNotesOnClick,
                            ],
                          },
                        }),
                        _vm._v(
                          "\n                        Is the pet on medication?\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: this.medicationNotesVisible,
                            expression: "this.medicationNotesVisible",
                          },
                        ],
                      },
                      [
                        _c(
                          "label",
                          {
                            attrs: {
                              "data-toggle": "tooltip",
                              for: "medicationNotesInput",
                            },
                          },
                          [_vm._v("Medication notes")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.petDetails.medicationNotes,
                              expression: "petDetails.medicationNotes",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "is-invalid": _vm.errors.has(
                              "medicationNotesInput"
                            ),
                          },
                          attrs: {
                            type: "text",
                            id: "medicationNotesInput",
                            autocomplete: "new-password",
                            name: "medicationNotesInput",
                            "data-vv-as": '"Medication notes"',
                          },
                          domProps: { value: _vm.petDetails.medicationNotes },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.petDetails,
                                "medicationNotes",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("medicationNotesInput"),
                                expression:
                                  "errors.has('medicationNotesInput')",
                              },
                            ],
                            staticClass: "invalid-feedback",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.errors.first("medicationNotesInput"))
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        attrs: {
                          "data-toggle": "tooltip",
                          for: "isNeuteredInput",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.petDetails.isNeutered,
                              expression: "petDetails.isNeutered",
                            },
                          ],
                          class: {
                            "is-invalid": _vm.errors.has("isNeuteredInput"),
                          },
                          attrs: {
                            type: "checkbox",
                            id: "isNeuteredInput",
                            autocomplete: "new-password",
                            name: "isNeuteredInput",
                            "data-vv-as": '"Has the pet been neutered?"',
                          },
                          domProps: {
                            checked: Array.isArray(_vm.petDetails.isNeutered)
                              ? _vm._i(_vm.petDetails.isNeutered, null) > -1
                              : _vm.petDetails.isNeutered,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.petDetails.isNeutered,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.petDetails,
                                      "isNeutered",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.petDetails,
                                      "isNeutered",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.petDetails, "isNeutered", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(
                          "\n                        Has the pet been neutered?\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("isNeuteredInput"),
                            expression: "errors.has('isNeuteredInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("isNeuteredInput")))]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _vm.startChatVisible
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          on: { click: _vm.startChat },
                        },
                        [_vm._v(" Start Chat")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.requestCallbackVisible
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          on: { click: _vm.requestCallback },
                        },
                        [_vm._v(" Request a callback")]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.getError
                  ? _c("div", { staticClass: "col-sm-auto" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-auto invalid-feedback",
                          staticStyle: { display: "block" },
                        },
                        [_vm._v(_vm._s(_vm.getError))]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "label-large" }, [
        _vm._v("Fill in the following details to continue"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "label-large" }, [_vm._v("Personal Details")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "label-large" }, [_vm._v("Pet Details")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("label", { staticClass: "label-large" }, [
          _vm._v(
            '\n                    By clicking "Start Chat", you are agreeing that the information you have given will be held by us on a computer and used as case notes and to provide management information.\n                '
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }